import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "@/store";
import axios from "axios";
import { required, maxLength, minValue, maxValue } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

const decimalOrNumber = (value) => {
  if (value === null || value === undefined || value === "") return true;
  return !isNaN(Number(value));
};

const GRADING_RULE_POINT_MAX = 999.99;
const GRADING_RULE_DECIMAL_SCALE = 2;
const GRADING_LETTER_MAX_LENGTH = 3;
const GRADING_RULE_MARK_MAX = 100;

const maxDecimalPlaces = (scale) => (value) => {
  if (value === null || value === undefined || value === "") return true;
  const parts = String(value).split(".");
  return !parts[1] || parts[1].length <= scale;
};

export default {
  name: "GradingRuleCreate",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: false,
      submitted: false,
      disabled: false,
      settingId: this.$route.params.gradingSettingId
        ? Number(this.$route.params.gradingSettingId)
        : 0,
      settingName: "",
      gradeMaxLength: GRADING_LETTER_MAX_LENGTH,
      markMax: GRADING_RULE_MARK_MAX,
      pointMax: GRADING_RULE_POINT_MAX,
      pointDecimalScale: GRADING_RULE_DECIMAL_SCALE,
      ruleData: {
        grade: "",
        min: "",
        max: "",
        point: "",
        sort_order: "",
        login_id: store.state.user.id,
      },
    };
  },

  validations: {
    ruleData: {
      grade: {
        required,
        maxLength: maxLength(GRADING_LETTER_MAX_LENGTH),
      },
      min: {
        required,
        decimalOrNumber,
        minValue: minValue(0),
        maxValue: maxValue(GRADING_RULE_MARK_MAX),
      },
      max: {
        required,
        decimalOrNumber,
        minValue: minValue(0),
        maxValue: maxValue(GRADING_RULE_MARK_MAX),
        gteMin(value) {
          if (value === "" || value === null || this.ruleData.min === "") return true;
          return Number(value) >= Number(this.ruleData.min);
        },
      },
      point: {
        decimalOrNumber,
        minValue: minValue(0),
        maxValue: maxValue(GRADING_RULE_POINT_MAX),
        maxDecimalPlaces: maxDecimalPlaces(GRADING_RULE_DECIMAL_SCALE),
      },
      sort_order: {
        numericOptional(value) {
          if (value === "" || value === null || value === undefined) return true;
          return Number.isInteger(Number(value)) && Number(value) >= 1;
        },
      },
    },
  },

  methods: {
    loadParentSetting() {
      this.isLoading = true;
      axios
        .get("gradingSetting/detail/" + this.settingId)
        .then((res) => {
          const setting = res.data && res.data.success ? res.data.data : null;
          if (!setting || !setting.id) {
            this.$router.push({ name: "gradingSettingList" });
            return;
          }
          if (setting.is_default) {
            this.$notification.error("Rules of the default grading setting cannot be modified.", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({
              name: "gradingSettingDetail",
              params: { id: this.settingId },
            });
            return;
          }
          this.settingName = setting.name;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.$router.push({ name: "gradingSettingList" });
        });
    },

    create() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;
      this.isLoading = true;
      const payload = {
        grade: this.ruleData.grade,
        min: this.ruleData.min,
        max: this.ruleData.max,
        point: this.ruleData.point === "" ? null : this.ruleData.point,
        sort_order: this.ruleData.sort_order === "" ? null : this.ruleData.sort_order,
        login_id: store.state.user.id,
      };
      axios
        .post("gradingSetting/" + this.settingId + "/rule/create", payload)
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Grading Rule Added Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({
              name: "gradingSettingDetail",
              params: { id: this.settingId },
            });
          } else {
            this.$notification.error(res.data.message || "Create failed", {
              timer: 3,
              position: "bottomCenter",
            });
            this.disabled = false;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Create failed";
          this.$notification.error(msg, {
            timer: 3,
            position: "bottomCenter",
          });
          this.disabled = false;
          this.isLoading = false;
        });
    },

    showDetail() {
      this.$router.push({
        name: "gradingSettingDetail",
        params: { id: this.settingId },
      });
    },
  },

  mounted() {
    this.loadParentSetting();
  },
};
